<div class="shift-reduction-dialog">
  <!-- Header -->
  <div class="flex items-start sm:items-center justify-between !px-4 !py-3 sm:!py-2 border-b border-slate-100 gap-3">
    <h2 mat-dialog-title class="!m-0 !p-0 text-[18px] font-bold text-slate-800 leading-tight flex-1">
      <span>Your plan allows fewer shifts</span>
    </h2>
    <button mat-icon-button class="text-slate-400 hover:text-slate-600 transition-colors shrink-0 -mt-1 sm:mt-0"
      (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content min-h-[300px]">

    <div class="flex flex-col mb-4 !max-w-[480px] !min-w-[320px]">
      <div *ngIf="loading" class="flex flex-col items-center justify-center py-12">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="text-slate-500 mt-4 font-medium text-[14px]">Loading shifts...</p>
      </div>

      <ng-container *ngIf="!loading">
        <!-- Warning box -->
        <div class="flex-col p-4 rounded-xl mb-5 bg-[#fffbeb] border border-solid border-[#fde68a] shadow-sm">
          <div class="flex gap-3 items-start w-full">
            <mat-icon class="text-[#d97706] shrink-0 mt-0.5">info</mat-icon>
            <div class="flex flex-col gap-1.5">
              <p class="text-[#92400e] text-[14px] font-medium !mb-0 !mt-0 leading-snug tracking-[inherit]">
                Deleting a shift will remove the shift configuration. <strong>Any assigned employees will be returned to the default tracking shift.</strong>
              </p>
            </div>
          </div>
        </div>
        <p class="text-[13.5px] text-slate-500 !mb-3 !mt-0 leading-relaxed">
          Delete extra custom shifts to meet plan limits.
        </p>

        <div *ngIf="shifts.length === 0" class="flex flex-col items-center justify-center py-10 gap-2 text-slate-500">
          <mat-icon class="!text-[32px] !w-[32px] !h-[32px] text-slate-300">schedule_off</mat-icon>
          <p class="m-0 text-[14px]">No shifts found.</p>
        </div>

        <div class="flex flex-col gap-2 mb-2" *ngIf="shifts.length > 0">
          <p class="text-[13.5px] font-medium text-slate-600 !m-0">Available shifts ({{ shifts.length }})</p>
          <div class="flex flex-col gap-2 overflow-y-auto max-h-[250px] pr-1">
            <div class="flex items-center justify-between p-3 rounded-lg border border-[#e5e7eb] bg-[#f6f7f9] transition-all hover:border-gray-300" *ngFor="let shift of shifts">
              <div class="flex flex-col flex-1 overflow-hidden pr-2">
                <p class="!text-[14px] font-semibold text-slate-800 m-0 leading-tight truncate">{{ shift.shift_name }}</p>
                <p class="!text-[12.5px] text-slate-500 m-0 leading-tight mt-1 flex items-center gap-1.5">
                  <mat-icon class="!text-[14px] !w-[14px] !h-[14px] text-slate-400">schedule</mat-icon>
                  {{ shift.start_time }} - {{ shift.end_time }}
                </p>
              </div>
              <button mat-icon-button color="warn" (click)="onDeleteShift(shift)" matTooltip="Delete Shift">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="flex flex-col-reverse sm:flex-row w-full justify-center sm:!justify-end gap-3 pt-4 pb-2 border-t border-slate-100 mt-2 !mb-0 px-4">
    <button mat-stroked-button type="button" class="action-secondary w-full sm:w-auto min-h-[40px] !m-0"
      (click)="onCancel()">Close</button>
  </mat-dialog-actions>
</div>
